<template>
  <base-dialog
    :visible="visible"
    :show-close="true"
    width="calc(100% - 400px)"
    class="dialog-wrap"
    border-radius="none"
    @open="open"
    @closed="closed"
  >
    <template v-slot:header>
      <div class="header-wrap">
        <div class="title">审批流</div>
      </div>
    </template>
    <main>
      <div class="top-wrap">
        <div class="right">
          <div class="mRight10">
            <el-input
              v-model="searchText"
              size="small"
              placeholder="搜索审批流"
              clearable
              @keyup.native.enter="search"
              @clear="search"
            >
              <el-button slot="append" icon="el-icon-search" @click="search"></el-button>
            </el-input>
          </div>
          <!-- <el-button type="primary" size="small" @click="toCreate">新建</el-button> -->
        </div>
      </div>
      <div class="main-wrap">
        <div v-if="!showTable" v-loading="!showTable" class="empty"></div>
        <base-table
          v-else
          ref="baseTable"
          table-height="100%"
          :tableColumns="tableColumns"
          :tableData="filterData"
          :showPagination="false"
          @row-click="rowClick"
          class="task-type-table"
        ></base-table>
      </div>
    </main>
  </base-dialog>
</template>

<script>
import BaseDialog from "@/components/BaseComponents/Dialog"
import BaseTable from "@/components/BaseComponents/Table"
import { getWorkflows } from "@/api/workflow/workflow"
import { stringIncludes } from "@/utils/common"

export default {
  name: "approval-workflow-dialog",
  components: { BaseDialog, BaseTable },
  props: {
    visible: Boolean
  },
  data() {
    const tableColumns = [
      {
        label: "审批流名称",
        value: "name",
        minWidth: "120",
        align: "center"
      },
      {
        label: "描述",
        value: "desc",
        minWidth: "240",
        align: "center"
      },
      {
        label: "创建人",
        value: "creator.name",
        minWidth: "120",
        align: "center"
      },
      {
        label: "创建时间",
        value: "createAt",
        minWidth: "160",
        align: "center"
      }
    ]
    return {
      searchText: "",
      showTable: false,
      tableColumns,
      workflowList: [],
      filterData: []
    }
  },
  methods: {
    open() {
      this.getWorkflow()
    },
    closed() {
      this.$emit("update:visible", false)
      this.searchText = ""
    },
    getWorkflow() {
      this.showTable = false
      return getWorkflows(this.$route.params.projectId).then(workflowList => {
        this.workflowList = workflowList
        this.filterData = this.workflowList
        this.showTable = true
      })
    },
    search() {
      this.filterData = this.workflowList.filter(i => stringIncludes(i.name, this.searchText))
    },
    rowClick(row) {
      this.$emit("submit", row)
    }
  }
}
</script>

<style lang="scss" scoped>
.dialog-wrap {
  main {
    height: 100%;
    display: flex;
    flex-direction: column;
  }
  .top-wrap {
    display: flex;
    align-items: center;
    margin: 8px 0;
    .right {
      margin-left: auto;
      display: flex;
      ::v-deep {
        .el-input-group__append {
          padding: 0 10px;
        }
      }
    }
  }
  .main-wrap {
    flex: 1 1;
    display: flex;
    overflow: hidden;
    .empty {
      width: 100%;
      justify-self: center;
    }
  }
  ::v-deep .el-dialog {
    min-width: 1080px;
    height: 86%;
    color: $color-font-first;
    .el-table__body-wrapper {
      .ps__rail-x {
        z-index: 10;
      }
    }
    .el-dialog__body {
      position: relative;
      padding: 0 !important;
      display: flex;
      flex-direction: column;
      height: 100%;
      width: 100%;
      .task-type-table {
        flex: auto;
        overflow: hidden;
        .el-table__body {
          tr {
            cursor: pointer;
          }
        }
      }
    }
    .el-dialog__footer .footer {
      border-bottom-width: 1px;
    }
  }
}
</style>
